import { updateSettingsBookingRulesApi as generatedUpdateSettingsBookingRulesApi } from '../generated/settingsBookingRules/updateSettingsBookingRules';

const bookingRulesUpdateBookingRulesApi = generatedUpdateSettingsBookingRulesApi.enhanceEndpoints({
  endpoints: {
    updateSettingsBookingRules: {
      invalidatesTags: ['SettingsBooking', 'Settings'],
    },
  },
});

export const { useUpdateSettingsBookingRulesMutation } = bookingRulesUpdateBookingRulesApi;
